import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Grid,
  Typography,
  Button,
  Box,
  FormControlLabel,
  Checkbox,
  styled,
  IconButton,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import GoogleIcon from "@mui/icons-material/Google";
import AppleIcon from "@mui/icons-material/Apple";
import Header from "components/common/dialog/Header";
import TabSwitch from "components/common/dialog/TabSwitch";
import { useFormik } from "formik";
import * as Yup from "yup";
import { emailRegex } from "services/utiles";
import { useDispatch } from "react-redux";
import { login } from "redux/slice/session/auth.slice";
import { assetsObj } from "services/images";
import Footer from "components/common/dialog/Footer";
import { signInWithFaceBook } from "services/firebase";
import { signInWithApple } from "services/firebase";
import Cookies from "js-cookie";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useGoogleLogin } from "@react-oauth/google";




import { googleLogin } from "services/firebase";
import { liveStr } from "services/utiles";

const WhiteBorderTextField = styled("input")({
  width: "100%",
  padding: "12px 14px",
  backgroundColor: "transparent",
  border: "1px solid white",
  borderRadius: "6px",
  color: "white",
  "&:focus": {
    borderColor: "#ffffff",
  },
  "&::placeholder": {
    color: "white",
  },
  "&:focus-visible ": {
    outline: "1px solid white",
  },
});

const GiftLogin = () => {
  const [getCookieData, setGetCookieData] = useState("");
  const cookieValue = Cookies.get("trakdesk_cid");



  useEffect(() => {
    if (cookieValue) {
      setGetCookieData(JSON.parse(cookieValue)?.cid);
    }
  }, [cookieValue]);

  sessionStorage.setItem("Take-cookies", getCookieData);



  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  // sessionStorage.setItem("pageType", location?.state?.type);

  let uT = sessionStorage.getItem('pageType') || 1

  const [agreed, setAgreed] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleAgreementChange = () => {
    setAgreed(!agreed);
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const loginGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => {
      googleLogin(dispatch, navigate, { status: 1, }, getCookieData, codeResponse, uT, { typeScreen: true });
    },
    onError: (error) => console.log('Login Failed:', error)
  });

  console.log('uT', uT);


  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,

    validationSchema: Yup.object({
      email: Yup.string()
        .email("Email is invalid")
        .matches(emailRegex, "Invalid email format")
        .required("Email is required"),
      password: Yup.string()
        .required("Password is required")
        .matches(/^(?=.*)(?=.{8,})/, "Must Contain 8 Characters"),
    }),

    onSubmit: (value) => {
      value["type"] = 1;
      value["registered_from"] = 1;

      setLoading(true);
      dispatch(login(value))
        .unwrap()
        .then((res) => {
          setLoading(false);
          if (res?.success) {
            localStorage.setItem("email", value.email)
            localStorage.setItem("success", res.success);
            toast.success(res?.message);
            sessionStorage.setItem("token", res?.data?.token);

            if (res?.data?.trial_updated == '1') {
              navigate(`/trial-success`)
            } else if (res?.data?.trial_updated === '0') {
              if (res?.data?.payment_status == '1') {
                if (res?.data?.trial_completed =='2') {                  
                  window.location.href = `${liveStr}?client_reference_id=${getCookieData}`;
                }
              } else if (res?.data?.payment_status == '2') {
                toast(
                  "You have an active subscription, please come back after your subscription expires.",
                  {}
                );
              } else if (res?.data?.payment_status == '3') {
                toast(
                  "Please wait till your subscripition's expiry date to purchase the subscription"
                );
              }
            }
          }
        });
    },
  });

  return (
    <>
      <Box
        sx={{
          height: "100%",
          color: "white",
          overflow: "auto",
          backgroundImage: `url(${assetsObj.gradientImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",

        }}
      >
        <Header />
        <TabSwitch
          backgroundC="#4A3467"
          colorD="#fff"
          backgroundA="#5B4A76"
          pathLogin={`/trial-login`}
          pathSignUp={`/trial-signup`}
          // pathSignUp="/app/trial-signup"
          path={location.pathname}
        />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            marginTop: "40px",
            maxWidth: "auto",

          }}
        >
          <Box maxWidth="md">
            <form onSubmit={formik.handleSubmit}>
              <Grid
                container
                item
                xs={11}
                md={6}
                justifyContent="center"
                margin="auto"
                alignItems="center"
                sx={{ marginBottom: 4.5 }}
              >
                <Grid item xs={12}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 400,
                      textAlign: "center",
                      color: "white",
                      marginBottom: 2,
                    }}
                  >
                    Log In
                  </Typography>
                </Grid>

                <Grid item xs={12} sx={{ marginBottom: 2 }}>
                  <WhiteBorderTextField
                    placeholder="Email"
                    type="input"
                    name="email"
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.email && (
                    <FormHelperText error>{formik.errors.email}</FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} sx={{ marginBottom: 1 }}>
                  <Box sx={{ position: "relative" }}>
                    <WhiteBorderTextField
                      sx={{ paddingRight: 4, mb: 0 }}
                      placeholder="Password (8+ characters)"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      onChange={formik.handleChange}
                      value={formik.values.password}
                    />
                    <IconButton
                      onClick={handleTogglePasswordVisibility}
                      sx={{
                        color: "white",
                        position: "absolute",
                        right: "0px",
                        top: "50%",
                        transform: "translate(-0%, -50%)",
                      }}
                    >
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </Box>
                  {formik.errors.password && (
                    <FormHelperText error>
                      {formik.errors.password}
                    </FormHelperText>
                  )}
                </Grid>

                <Link
                  to="/trial/forgot-password"
                  style={{
                    color: "White",
                    display: "inline-block",
                    marginLeft: "auto",
                    fontWeight: 400,
                    fontSize: "14px",
                    outline: "none",
                    // textDecoration: "none",
                  }}
                >
                  Forgot Password ?
                </Link>

                <Grid item xs={12}>
                  <FormControlLabel
                    sx={{ marginBottom: 2 }}
                    control={
                      <Checkbox
                        checked={agreed}
                        onChange={handleAgreementChange}
                        sx={{
                          color: "white",
                          fontWeight: 600,
                          "&.Mui-checked": {
                            color: "white",
                          },
                        }}
                      />
                    }
                    label={
                      <span className="your-component">
                        I agree to Affirmate’s{" "}
                        <a
                          href="https://affirmate.app/terms/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "white",
                            fontWeight: 300,
                            textDecoration: "none",
                          }}
                        >
                          Terms{" "}
                        </a>
                        <span>& </span>
                        <a
                          href="https://affirmate.app/privacy/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "white",
                            fontWeight: 300,
                            textDecoration: "none",
                          }}
                        >
                          Privacy Policy
                        </a>
                      </span>
                    }
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "60px",
                      width: "50%",
                      background: "transparent",
                      marginBottom: 2,
                      border: "1px solid white",
                      "&:hover": {
                        background: "white",
                        color: "black",
                        transition: "0.2s ease-in-out",
                      },
                      mx: "auto",
                    }}
                    type="submit"
                    disabled={!agreed}
                  >
                    {loading ? (
                      <CircularProgress size={22} color="secondary" />
                    ) : (
                      "Log In"
                    )}
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontWeight: 400,
                      marginBottom: 1,
                    }}
                  >
                    Or continue with
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      onClick={() =>
                        signInWithFaceBook(
                          dispatch,
                          navigate,
                          { status: 1 },
                          getCookieData,
                          uT,
                          { typeScreen: true }
                        )
                      }
                      sx={{
                        color: "white",
                        "&:hover": { background: "transparent" },
                      }}
                    >
                      <FacebookOutlinedIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => loginGoogle()}
                      sx={{
                        color: "white",
                        "&:hover": { background: "transparent" },
                      }}
                    >
                      <GoogleIcon />
                    </IconButton>
                    <IconButton
                      // onClick={() =>
                      //   signInWithApple(
                      //     dispatch,
                      //     navigate,
                      //     { status: 1,typeScreen: true },
                      //     getCookieData, uT,
                      //     {typeScreen: true }
                      //   )
                      // }
                      onClick={() =>
                        signInWithApple(dispatch,navigate,{ status: 1 }, getCookieData, uT, 
                            { typeScreen: true })
                      }
                      sx={{
                        color: "white",
                        "&:hover": { background: "transparent" },
                      }}
                    >
                      <AppleIcon />
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default GiftLogin;
